/* Boost kartlarına kalp düğmesi enjekte eder. iWish'in yerini alan parça.
 *
 * NEDEN AYRI BİR DOSYA: temanın kalbi (assets/wl-heart.js) zaten bizim
 * sistemimize bağlı — /a/favoriler/api/liste'den listeyi okuyor, /degistir'e
 * yazıyor, [data-wl-variant] taşıyan her düğmeyi boyuyor. Ama o düğmeleri
 * Liquid basıyor ve Boost koleksiyon/arama ızgarasını tamamen JS ile çiziyor:
 * Liquid oraya hiç uğramıyor, dolayısıyla tutunacak düğme yok. Boşluk buydu,
 * iWish de bu yüzden oralarda tek başına kalmıştı.
 *
 * Bu dosya kalbi ÇİZMİYOR, sadece düğmeyi yerine koyuyor. Durum, tıklama,
 * sunucuya yazma, hepsi wl-heart.js'te; iki yerde iki mantık istemiyoruz.
 * wl-heart.js'in MutationObserver'ı enjeksiyonu görüp düğmeyi boyuyor.
 *
 * Temaya eklerken: wl-heart.js'ten SONRA yükle.
 */
(function () {
  'use strict';

  // Boost'un ızgara kartı ve içindeki görsel kutusu. Boost sürüm atlarsa
  // değişebilecek tek yer burası.
  var CARD_SEL = '.boost-sd__product-item';
  var HOST_SEL = '.boost-sd__product-link-image, .boost-sd__product-image';

  // Temanın kendi kalbiyle aynı ikon — iki farklı kalp görünmesin.
  var SVG = '<svg viewBox="0 0 256 256" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="16" stroke-linecap="round" stroke-linejoin="round"><path d="M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z"></path></svg>';

  /**
   * Karttaki varyant. Boost her kartın data-product'ında JSON olarak veriyor;
   * asıl kaynak o. iWish henüz kaldırılmadıysa kendi düğmesinde de duruyor,
   * onu yedek olarak okuyoruz — geçiş sırasında ikisi yan yana çalışsın.
   */
  function variantOf(card) {
    var raw = card.getAttribute('data-product');
    if (raw && raw.indexOf('{') >= 0) {
      try {
        var j = JSON.parse(raw);
        if (j && j.variantId) return String(j.variantId);
      } catch (e) {}
    }
    var iw = card.querySelector('[data-variant]');
    return iw ? String(iw.getAttribute('data-variant') || '') : '';
  }

  function mount() {
    var cards = document.querySelectorAll(CARD_SEL);

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('[data-wl-variant]')) continue;   // zaten takılı

      var id = variantOf(card);
      if (!id) continue;                                       // varyantı okunamadı

      var host = card.querySelector(HOST_SEL);
      if (!host) continue;
      // Kalp mutlak konumlanıyor; kap statikse çapa olamaz.
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wlh wlh--boost';
      btn.setAttribute('data-wl-variant', id);
      // Boyamayı wl-heart.js yapıyor; ilk hâl "henüz bilinmiyor" olduğu için
      // etiketi de o yazacak. Buradaki, ekran okuyucu boşta kalmasın diye.
      btn.setAttribute('aria-label', 'Favorilere ekle');
      btn.innerHTML = SVG;

      host.appendChild(btn);
    }
  }

  // Boost süzgeç, sıralama ve sayfa geçişlerinde ızgarayı baştan yazıyor;
  // her seferinde yeniden takmak gerekiyor. 120ms'lik bekleme, tek bir
  // yeniden çizimin onlarca tura bölünmesini engelliyor.
  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; mount(); }, 120);
  }

  function start() {
    mount();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
